import "./styles/LoadingOverlay.css";

function LoadingOverlay() {
  return (
    <div className="boot-popup">
      <div className="boot-popup-inner">
        <img
          src="/assets/themes/imac-g3/images/MacOS_Logo.png"
          alt="MacOS8 Logo"
          className="boot-logo"
        />
        <div className="boot-status">
          <span>Starting Up...</span>
          <div className="boot-progress-bar">
            <div className="boot-progress-fill" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoadingOverlay;
